import React, { useEffect, useState } from "react";
import "../assets/css/Home.css";
import "../assets/css/animations.css";

import AOS from "aos";
import "aos/dist/aos.css";

import test from "../assets/images/godzillanew.mp4";
import dino from "../assets/images/Dino.m4v";
import TwitterIcon from "@mui/icons-material/Twitter";
import TelegramIcon from "@mui/icons-material/Telegram";
import ArrowCircleUpOutlined from "@mui/icons-material/KeyboardArrowUpRounded";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import Maincarousel from "./Maincarousel";
import medium from "../assets/images/medium.png";

import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";

import useWindowDimensions from "../helpers/windowDimensions";
import { useNavigate } from "react-router-dom";

function Home() {
  let navigate = useNavigate();
  const [scrollPosition, setSrollPosition] = useState(0);
  const [showGoTop, setshowGoTop] = useState(false);
  const { height, width } = useWindowDimensions();
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
  useEffect(() => {
    window.addEventListener("scroll", handleVisibleButton);
  });
  const handleVisibleButton = () => {
    const position = window.pageYOffset;
    setSrollPosition(position);

    if (scrollPosition > 100) {
      return setshowGoTop(true);
    } else if (scrollPosition < 100) {
      return setshowGoTop(false);
    }
  };
  function gotop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
  const Item = styled("div")(({ theme }) => ({
    background:
      "linear-gradient(105.42deg, rgba(255, 255, 255, 0.12) -3.07%, rgba(255, 255, 255, 0.15) 49.04%, rgba(0, 0, 0, 0) 97.84%)",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    margin: "1rem",
    display: "flex",
    borderRadius: "40px",
    flexDirection: "column",
    width: "260px",
    height: "290px",
    textAlign: "center",
    justifyContent: "center",
    color: theme.palette.text.secondary,
  }));
  return (
    <div className="Home">
      {showGoTop ? (
        <>
          <div
            data-aos="fade-up"
            style={{
              zIndex: 90,
              position: "fixed",
              bottom: 33,
              right: 23,
              background: "black",
              borderRadius: 25,
            }}
          >
            <ArrowCircleUpOutlined
              style={{ width: 50, height: 50, borderRadius: 25 }}
              onClick={gotop}
            />
          </div>
        </>
      ) : (
        <></>
      )}
      <section
        data-aos="zoom-in-up"
        data-aos-offset="200"
        className="Home__main"
      >
        <video
          playsinline
          autoplay="autoplay"
          muted
          loop
          className="back-video"
        >
          <source src="webm" type="video/webm" />
          <source type="video/mp4" src={test} />
        </video>
        <div className="main__box">
          <div
            data-aos="zoom-out-up"
            data-aos-offset="200"
            data-aos-easing="ease-in-sine"
            className="main__head"
          >
            GODZILLA PROJECT
          </div>
          <div className="main__sub">
            Emerged from the deep seas, roaming the Web3 world
          </div>
          <div className="main__button">
            <a
              href="/Godzilla Whitepaper V2.pdf"
              rel="noreferrer"
              target="_blank"
              className="main__link"
            >
              Whitepaper
            </a>
          </div>
        </div>
        <div className="main__boxList">
          <a
            href="https://twitter.com/Godzilla_io"
            target="_blank"
            rel="noreferrer"
          >
            <TwitterIcon />
          </a>
          <a href="https://t.me/Godzilla_io" target="_blank" rel="noreferrer">
            <TelegramIcon />
          </a>
          <a
            href="https://medium.com/@Godzilla_io"
            target="_blank"
            rel="noreferrer"
          >
            <img
              style={{ width: "30px", height: "30px" }}
              src={medium}
              alt="logo"
            />
          </a>
        </div>
      </section>

      <section
        data-aos="fade-up"
        data-aos-offset="200"
        className="Home__about"
        id="about"
      >
        <div className="about__row">
          <div
            className="about__col"
            style={{
              marginLeft: width > 750 ? "10%" : 0,
              marginRight: width > 750 ? "10%" : 0,
            }}
          >
            <div
              style={{
                width: "100%",
                textAlign: "center",
              }}
              className="about__head"
            >
              About us
            </div>
            <div style={{ textAlign: "center" }} className="about__sub">
              Godzilla Project is a community run project, launched fairly with
              100% of the GODZ tokens on the market from the token launch on
              decentralized exchanges. This means there won't be any inflation
              in the supply, and there's no team tokens and no prefunding
              rounds.
              <br></br>
              <br></br>The token is deflationary through Buy/Sell tax and
              Transaction tax resulting in token burns, making the GODZ token
              scarce. The GODZ token has been audited by InterFi Network.
            </div>
          </div>
        </div>
      </section>

      <section
        style={{ backgroundColor: "rgba(0,0,0,0.3)" }}
        data-aos="fade-up"
        data-aos-offset="200"
        className="Home__tvc"
        id="tvc"
      >
        <div className="tvc__head">Token Value Capture</div>
        <div className="tvc__row">
          <div
            data-aos={width > 500 ? "flip-left" : "zoom-out-up"}
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000"
            className={width > 500 ? "tvc__col" : "tvc__col noHover"}
          >
            <div
              style={{
                marginTop: "30px",
                height: width > 600 ? "80px" : "50px",
              }}
              className="tvc__colHead"
            >
              Taxes
            </div>
            <div className="tvc__colSub">
              A tax is deducted when you buy/sell/transfer. The taxes funds
              Operations, Liquidity Pools, Staking, Token Burns
            </div>
          </div>
          <div
            data-aos={width > 500 ? "flip-left" : "zoom-out-up"}
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000"
            className={width > 500 ? "tvc__col" : "tvc__col noHover"}
          >
            <div
              style={{
                marginTop: "30px",
                height: width > 600 ? "80px" : "50px",
              }}
              className="tvc__colHead"
            >
              Staking Rewards
            </div>
            <div className="tvc__colSub">
              Stake your $GODZ tokens and earn Rewards funded by the Buy/Sell
              Tax
            </div>
          </div>
          <div
            data-aos={width > 500 ? "flip-left" : "zoom-out-up"}
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000"
            className={width > 500 ? "tvc__col" : "tvc__col noHover"}
          >
            <div
              style={{
                marginTop: "30px",
                height: width > 600 ? "80px" : "50px",
              }}
              className="tvc__colHead"
            >
              Token Burns
            </div>
            <div className="tvc__colSub">
              Stake your $GODZ tokens and earn Rewards funded by the Buy/Sell
              Tax
            </div>
          </div>
        </div>
      </section>

      <section data-aos="fade-up" className="Home__toks" id="tokenomics">
        <div className="toks__head">Godzilla Tokenomics</div>
        <div className="toks__sub">
          Token Overview including details about Transaction Tax and Buy/Sell
          Tax
        </div>
        <Box>
          <Grid
            container
            rowSpacing={2}
            columnSpacing={{ sm: 3, xl: 11 }}
            justifyContent="space-around"
          >
            <Grid
              item
              sm={5}
              md={2.75}
              xl={3}
              data-aos="fade-right"
              data-aos-easing="ease-in-sine"
            >
              <Item
                style={{
                  justifyContent: width < 600 ? "center" : "flex-start",
                  paddingTop: width < 600 ? "0" : "55px",
                }}
              >
                <div className="toks__colHead">$GODZ</div>
                <div className="toks__colsub">The Token Ticker is $GODZ</div>
              </Item>
            </Grid>
            <Grid
              item
              sm={5}
              md={2.75}
              xl={3}
              data-aos="fade-right"
              data-aos-easing="ease-in-sine"
            >
              <Item
                style={{
                  justifyContent: width < 600 ? "center" : "flex-start",
                  paddingTop: width < 600 ? "0" : "55px",
                }}
              >
                <div className="toks__colHead">100B</div>
                <div className="toks__colsub">Total Supply</div>
              </Item>
            </Grid>
            <Grid
              item
              sm={5}
              md={2.75}
              xl={3}
              data-aos="fade-right"
              data-aos-easing="ease-in-sine"
            >
              <Item
                style={{
                  justifyContent: width < 600 ? "center" : "flex-start",
                  paddingTop: width < 600 ? "0" : "55px",
                }}
              >
                <div className="toks__colHead">BEP20</div>
                <div className="toks__colsub">Issued on BNB</div>
              </Item>
            </Grid>
            <Grid
              item
              sm={5}
              md={2.75}
              xl={3}
              data-aos="fade-right"
              data-aos-easing="ease-in-sine"
            >
              <Item
                style={{
                  justifyContent: width < 600 ? "center" : "flex-start",
                  paddingTop: width < 600 ? "0" : "55px",
                }}
              >
                <div className="toks__colHead">$1%</div>
                <div className="toks__colsub">Transaction Tax</div>
              </Item>
            </Grid>
            <Grid
              item
              sm={5}
              md={2.75}
              xl={3}
              data-aos="fade-left"
              data-aos-easing="ease-in-sine"
            >
              <Item
                style={{
                  justifyContent: width < 600 ? "center" : "flex-start",
                  paddingTop: width < 600 ? "0" : "55px",
                }}
              >
                <div className="toks__colHead">6%</div>
                <div className="toks__colsub">Buy/Sell Tax</div>
              </Item>
            </Grid>
            <Grid
              item
              sm={5}
              md={2.75}
              xl={3}
              data-aos="fade-left"
              data-aos-easing="ease-in-sine"
            >
              <Item
                style={{
                  justifyContent: width < 600 ? "center" : "flex-start",
                  paddingTop: width < 600 ? "0" : "55px",
                }}
              >
                <div className="toks__colHead">3%</div>
                <div className="toks__colsub">Liquidity Pool</div>
              </Item>
            </Grid>
            <Grid
              item
              sm={5}
              md={2.75}
              xl={3}
              data-aos="fade-left"
              data-aos-easing="ease-in-sine"
            >
              <Item
                style={{
                  justifyContent: width < 600 ? "center" : "flex-start",
                  paddingTop: width < 600 ? "0" : "55px",
                }}
              >
                <div className="toks__colHead">2%</div>
                <div className="toks__colsub">OPS, Marketing, Staking</div>
              </Item>
            </Grid>
            <Grid
              item
              sm={5}
              md={2.75}
              xl={3}
              data-aos="fade-left"
              data-aos-easing="ease-in-sine"
            >
              <Item
                style={{
                  justifyContent: width < 600 ? "center" : "flex-start",
                  paddingTop: width < 600 ? "0" : "55px",
                }}
              >
                <div className="toks__colHead">1%</div>
                <div className="toks__colsub">Token Burns</div>
              </Item>
            </Grid>
          </Grid>
        </Box>

        <div
          className="tvc__head"
          style={{
            fontSize: "5rem",
            paddingBottom: "0",
          }}
        >
          $GODZ Token Links
        </div>
        <div className="tvc__head_small">Token Contract Address</div>

        <Item
          style={{
            justifyContent: width < 600 ? "center" : "center",
            flexDirection: "row",
            paddingTop: width < 600 ? "0" : "10px",
            width: "100%",
            height: "auto",
            margin: "0",
          }}
        >
          <div className="toks__fulsub">
            0xae7cf30e14e132e43689ebe4fab49706c59a0bf7
          </div>
          <OpenInNewIcon
            class="redirect_icon"
            onClick={() => {
              window.open(
                "https://bscscan.com/address/0xae7cf30e14e132e43689ebe4fab49706c59a0bf7"
              );
            }}
          />
        </Item>
        <div className="tvc__head_small">Pancakeswap Pool</div>
        <Item
          style={{
            justifyContent: width < 600 ? "center" : "center",
            flexDirection: "row",
            paddingTop: width < 600 ? "0" : "10px",
            width: "100%",
            height: "auto",
            margin: "0",
          }}
        >
          <div className="toks__fulsub">
            0xd1d9ad05238993a9c10c5b17c4ec6d03b9d35138
          </div>
          <OpenInNewIcon
            class="redirect_icon"
            onClick={() => {
              window.open(
                "https://pancakeswap.finance/info/pairs/0xd1d9ad05238993a9c10c5b17c4ec6d03b9d35138"
              );
            }}
          />
        </Item>
        <div className="tvc__head_small">Dextools</div>
        <Item
          style={{
            justifyContent: width < 600 ? "center" : "center",
            flexDirection: "row",
            paddingTop: width < 600 ? "0" : "10px",
            width: "100%",
            height: "auto",
            margin: "0",
          }}
        >
          <div className="toks__fulsub">
            0xd1d9ad05238993a9c10c5b17c4ec6d03b9d35138
          </div>
          <OpenInNewIcon
            class="redirect_icon"
            onClick={() => {
              window.open(
                "https://www.dextools.io/app/en/bnb/pair-explorer/0xd1d9ad05238993a9c10c5b17c4ec6d03b9d35138"
              );
            }}
          />
        </Item>
      </section>

      <section
        data-aos="fade-up"
        data-aos-offset="200"
        className="Home__taxes"
        id="taxes"
      >
        <div className="tax__row">
          <div className="tax__col">
            <div className="tax__colBox">
              <div style={{ paddingTop: "35%" }} className="tax__head">
                Buy/Sell Taxes
              </div>
              <Maincarousel />
            </div>
          </div>
          <video
            playsinline
            autoplay="autoplay"
            muted
            loop
            className="back-video"
          >
            <source src="webm" type="video/webm" />
            <source type="video/mp4" src={dino} />
          </video>
          <div className="tax__col">
            {/* <div className='about__circle'></div> */}
          </div>
        </div>
      </section>
      <div className="Home__ellipse2"></div>
      <section
        data-aos="fade-up"
        data-aos-offset="200"
        className="Home__rm"
        id="roadmap"
      >
        <div className="rm__head">RoadMap</div>
        <div className="rm__row">
          <div className="rm__col num-1">
            <div data-aos="zoom-out-up" className="rm__box">
              <div className="rm__boxHead">Stage 1</div>
              <div className="rm__boxSub">
                <ul>
                  <li>Project Launch</li>
                  <li>Whitepaper v1</li>
                  <li>Tokenomics</li>
                  <li>Branding</li>
                  <li>Website creation</li>
                  <li>Strategy planning</li>
                  <li>Team expansion</li>
                </ul>
              </div>
              <a
                target="_blank"
                rel="noreferrer"
                href="/Godzilla Whitepaper V2.pdf"
              >
                <div className="rm__boxLm">Learn More</div>
              </a>
            </div>
            <div data-aos="zoom-out-up" className="rm__box hi">
              <div className="rm__boxHead">Stage 2</div>
              <div className="rm__boxSub">
                <ul>
                  <li>Smart contract development</li>
                  <li>Token creation</li>
                  <li>Marketing</li>
                  <li>Token launch on Pancakeswap</li>
                  <li>Buy/Sell tax activation</li>
                  <li>Team expansion</li>
                </ul>
              </div>
              <a
                target="_blank"
                rel="noreferrer"
                href="/Godzilla Whitepaper V2.pdf"
              >
                <div className="rm__boxLm">Learn More</div>
              </a>
            </div>
            <div data-aos="zoom-out-up" className="rm__box">
              <div className="rm__boxHead">Stage 3</div>
              <div className="rm__boxSub">
                <ul>
                  <li>Native GODZ Staking</li>
                  <li>Token Bridge & Uniswap Pool</li>
                  <li>Web Swap Interface</li>
                  <li>Godzilla NFTs</li>
                  <li>Godzilla Mobile Wallet</li>
                </ul>
              </div>
              <a
                target="_blank"
                rel="noreferrer"
                href="/Godzilla Whitepaper V2.pdf"
              >
                <div className="rm__boxLm">Learn More</div>
              </a>
            </div>
          </div>
          <div className="rm__col num-2">
            <div data-aos="zoom-out-up" className="rm__box">
              <div className="rm__boxHead">Stage 2</div>
              <div className="rm__boxSub">
                <ul>
                  <li>Smart contract creation</li>
                  <li>Token creation</li>
                  <li>Marketing</li>
                  <li>Token launch on Pancakeswap</li>
                  <li>Buy/Sell tax activation</li>
                  <li>Team expansion</li>
                </ul>
              </div>
              <a
                target="_blank"
                rel="noreferrer"
                href="/GodzillaWhitepaper.pdf"
              >
                <div className="rm__boxLm">Learn More</div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <div className="about__circle2"></div>
    </div>
  );
}

export default Home;
